import type { LocalText, OptionGroup } from './types';

/** Baht text the owner types -> satang integer; null if not a valid price (max 2 decimals, up to ฿100,000). */
export function parseBaht(s: string): number | null {
  const t = s.replace(/[,฿\s]/g, '');
  if (!/^\d{1,6}(\.\d{1,2})?$/.test(t)) return null;
  const v = Math.round(Number(t) * 100);
  return v <= 10_000_000 ? v : null;
}
export const satangToInput = (s: number) => (s % 100 === 0 ? String(s / 100) : (s / 100).toFixed(2));

export interface DraftItem {
  id?: string;
  categoryId: string;
  name: LocalText;
  description?: LocalText;
  priceSatang: number;
  photoId?: string;
  options: OptionGroup[];
  sort?: number;
  station?: string;
}

/** Problems to show before saving (the server validates too). */
export function itemProblems(it: DraftItem): string[] {
  const p: string[] = [];
  if (!it.name.th?.trim() && !it.name.en?.trim()) p.push('ใส่ชื่อเมนู · Name is required');
  it.options.forEach((g, i) => {
    const label = g.name.th || g.name.en || `group ${i + 1}`;
    if (!g.name.th?.trim() && !g.name.en?.trim()) p.push(`ตัวเลือกที่ ${i + 1}: ใส่ชื่อ · option group needs a name`);
    if (g.choices.length === 0) p.push(`${label}: add at least one choice`);
    if (g.choices.some((c) => !c.name.th?.trim() && !c.name.en?.trim())) p.push(`${label}: every choice needs a name`);
    if (g.min > g.max) p.push(`${label}: minimum is more than maximum`);
    if (g.max > g.choices.length) p.push(`${label}: maximum is more than the number of choices`);
  });
  return p;
}

let n = 0;
export const tmpId = (prefix: string) => `${prefix}${Date.now().toString(36)}${(n++).toString(36)}`;
